import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { CampaignService } from "../services/Campaign.service";
import { IEditManualPayout } from "@shared/lib/types/briefCampains";
import { FINANCE_INFLUENCER_QUERY_KEY } from "../contsants";

export function useEditManualPayout(campaignInfluencerId: string) {
  const {
    mutate: editManualPayout,
    isLoading: isEditing,
    isSuccess: isEdited,
  } = useMutation<IEditManualPayout>({
    mutationFn: async (payout) => {
      return await CampaignService.editManualPayout(payout).catch(
        async (err) => {
          const responseBody = await err.response.json();
          ToastService.error(responseBody.msg);
          throw err;
        }
      );
    },
    onSuccess: (c) => {
      c.invalidateQueries({
        queryKey: [...FINANCE_INFLUENCER_QUERY_KEY(campaignInfluencerId)],
      });
      // TODO: Invalidate relevant queries here
    },
    options: {},
  });

  return {
    editManualPayout,
    isEditing,
    isEdited,
  };
}
